// Russian translations

const messages = {
    // Navbar
    navbar_admin_portal: 'Admin Portal',
    navbar_consumer_search: 'Пользовательский поиск',
    navbar_language_choose_language: 'Выберите язык',
    navbar_market_choose_market: 'Выберите рынок',
    navbar_logout: 'Выход',

    // Home page
    homepage_title: 'Добро пожаловать',
    homepage_welcome: 'Добро пожаловать на Admin Portal',
    homepage_not_allowed: 'Вы не имеете права использовать это приложение.',
    homepage_search_btn: 'Потребительский поиск',
    homepage_login_btn: 'Логин',
    homepage_logout_btn: 'Выход',

    // Search page
    searchpage_title: 'Пользовательский поиск',
    searchpage_no_consumers_found: 'Пользователи не найдены.',
    searchpage_section_person: 'Человек',
    searchpage_section_address: 'Адрес',
    searchpage_btn_search: 'Поиск',
    searchpage_btn_clear: 'Очистить',
    searchpage_field_uid: 'ID пользователя',
    searchpage_field_first_name: 'Имя',
    searchpage_field_last_name: 'Фамилия',
    searchpage_field_dob: 'Дата рождения ({0})',
    searchpage_field_email: 'Адрес электронной почты',
    searchpage_field_phone: 'Номер телефона',
    searchpage_field_address: 'Адрес',
    searchpage_field_city: 'Город',
    searchpage_field_postal: 'Почтовый индекс',
    searchpage_invalid_uid: 'Недействительный ID пользователя',
    searchpage_invalid_date: 'Неверная дата.',
    searchpage_invalid_email: 'Недействительный адрес электронной почты.',
    searchpage_invalid_phone: 'Неверный номер телефона.',
    searchpage_invalid_wildcard:
        'Недопустимое использование подстановочного знака (*). Разрешен один подстановочный знак при использовании в одиночку.',
    searchpage_column_first_name: 'Имя',
    searchpage_column_last_name: 'Фамилия',
    searchpage_column_address: 'Адрес',
    searchpage_column_dob: 'Дата рождения',
    searchpage_column_email: 'Адрес электронной почты',
    searchpage_column_phone: 'Номер телефона',
    searchpage_column_actions: 'Действия',
    searchpage_menu_view_profile: 'Посмотреть профиль',
    searchpage_menu_age_verification: 'Проверка возраста',
    searchpage_menu_marketing_prefs: 'Маркетинговые предпочтения',
    searchpage_menu_password_reset: 'Сброс пароля',
    searchpage_menu_consumer_delete: 'Удаление пользователя',

    // Consumer page: tab names
    consumerpage_title: 'Профиль пользователя',
    consumerpage_tab_system: 'Система',
    consumerpage_tab_personal: 'Личный',
    consumerpage_tab_address: 'Адресные данные',
    consumerpage_tab_marketing_prefs: 'Маркетинговые предпочтения',
    consumerpage_tab_age_verification: 'Проверка возраста',
    consumerpage_tab_loyalty_data: 'Программы лояльности',

    // Consumer page: tab names - market specific
    consumerpage_tab_communication_prefs: 'Настройки связи',

    // Consumer page: action buttons
    consumerpage_action_label_disabled: 'Отключено',
    consumerpage_action_label_deleted: 'Удалено',
    consumerpage_action_label_locked: 'Заблокировано',
    consumerpage_action_nav_back: 'Вернуться к поиску',
    consumerpage_action_btn_edit: 'Редактировать',
    consumerpage_action_btn_save: 'Сохранить',
    consumerpage_action_btn_cancel: 'Отменить',
    consumerpage_action_btn_reset_password: 'Сброс пароля',
    consumerpage_action_btn_block_consumer: 'Заблокировать пользователя',
    consumerpage_action_btn_unblock_consumer: 'Разблокировать пользователя',
    consumerpage_action_btn_delete_consumer: 'Удалить пользователя',
    consumerpage_action_btn_set_hav_status: 'Установка статуса HAV',
    consumerpage_action_btn_assign_points: 'Присвоение баллов',

    // Consumer page: validation errors
    consumerpage_error_rejected_by_server: 'Значение отклонено сервером.',
    consumerpage_error_required: 'Поле обязательно для заполнения.',
    consumerpage_error_too_long: 'Значение слишком долгое.',
    consumerpage_error_date: 'Неверная дата.',
    consumerpage_error_date_in_future: 'Дата в будущем.',
    consumerpage_error_age_under_18: 'Примечание: Возраст менее 18 лет.',
    consumerpage_error_email: 'Недействительный адрес электронной почты.',
    consumerpage_error_phone: 'Неверный номер телефона.',
    consumerpage_error_country: 'Недействительная страна.',
    consumerpage_error_province: 'Недействительная провинция.',
    consumerpage_error_city: 'Неверный город.',
    consumerpage_error_postal: 'Неверный почтовый индекс.',

    // Consumer page: System tab
    consumerpage_system_section_blockings: 'Блокировки',
    consumerpage_system_section_blockings_hist_data: 'Исторические данные',
    consumerpage_system_field_consumer_id: 'ID пользователя',
    consumerpage_system_field_created: 'Созданный',
    consumerpage_system_field_registered: 'Зарегистрированный',
    consumerpage_system_field_registration_time: 'Время регистрации',
    consumerpage_system_field_registration_brand: 'Регистрация бренда',
    consumerpage_system_field_registration_channel: 'Канал регистрации',
    consumerpage_system_field_touchpoint_type: 'Тип взаимодействия',
    consumerpage_system_field_touchpoint_id:
        'Идентификатор точки взаимодействия',
    consumerpage_system_field_telegram_chat_id: 'Идентификатор чата Telegram',
    consumerpage_system_field_account_locked: 'Учетная запись заблокирована',
    consumerpage_system_field_login_allowed: 'Вход в систему разрешен',
    consumerpage_system_field_last_login: 'Последний вход в систему',
    consumerpage_system_field_last_updated: 'Последнее обновление',
    consumerpage_system_field_last_updated_by: 'Последним обновил',
    consumerpage_system_field_blockedBy: 'Заблокировано',
    consumerpage_system_field_blockedReason: 'Причина блокировки',
    consumerpage_system_field_blockedDate: 'Дата блокировки',

    // Consumer page: Personal tab
    consumerpage_personal_field_first_name: 'Имя',
    consumerpage_personal_field_last_name: 'Фамилия',
    consumerpage_personal_field_full_name: 'Имя',
    consumerpage_personal_field_dob: 'Дата рождения',
    consumerpage_personal_field_gender: 'Пол',
    consumerpage_personal_field_email: 'Адрес электронной почты',
    consumerpage_personal_field_language: 'Язык',
    consumerpage_personal_field_home_country: 'Родина',
    consumerpage_personal_field_mobile_phone: 'Мобильный телефон',
    consumerpage_personal_field_home_phone: 'Домашний телефон',
    consumerpage_personal_field_mobile_verification_status:
        'Статус подтверждения мобильного номера',
    consumerpage_personal_field_mobile_verification_date:
        'Дата подтверждения мобильного номера',

    // OTP Phone change
    consumerpage_personal_btn_phone_change: 'Изменить номер телефона',
    consumerpage_personal_btn_phone_verify: 'Verify OTP Code',

    // Consumer page: Address tab
    consumerpage_address_field_addr_type: 'Тип адреса',
    consumerpage_address_field_country: 'Страна',
    consumerpage_address_field_province: 'Провинция',
    consumerpage_address_field_city: 'Город',
    consumerpage_address_field_addr_line_1: 'Адресная линия 1',
    consumerpage_address_field_addr_line_2: 'Адресная линия 2',
    consumerpage_address_field_postal: 'Почтовый индекс',

    // Consumer page: Marketing Prefs tab
    consumerpage_marketing_section_channel: 'Согласие на получение сообщений',
    consumerpage_marketing_section_brand:
        'Согласие на получение сообщений от брендов',
    consumerpage_marketing_section_brand_seg: 'Сегментация бренда',
    consumerpage_marketing_section_brand_pref: 'Предпочтения бренда',
    consumerpage_marketing_field_opt_email: 'Получать электронную почту',
    consumerpage_marketing_field_opt_sms: 'Получать сообщения',
    consumerpage_marketing_field_opt_calls: 'Получать телефонные звонки',
    consumerpage_marketing_field_opt_dm: 'Получать письма по почте',
    consumerpage_marketing_field_opt_telegram: 'Получать сообщения в Telegram',
    consumerpage_marketing_field_opt_brand: 'Получать сообщения от бренда',
    consumerpage_marketing_field_brand: 'Бренд',
    consumerpage_marketing_field_subbrand: 'Суббренд',
    consumerpage_marketing_msg_choose_brand: 'Выберите бренд',
    consumerpage_marketing_msg_choose_subbrand: 'Выберите суббренд',
    consumerpage_marketing_msg_invalid_brand: '<Неверный бренд>',
    consumerpage_marketing_msg_invalid_subbrand: '<Недействительный суббренд>',

    // Consumer page: Age Verification tab
    consumerpage_age_section_label_hav: 'Проверка возраста (HAV)',
    consumerpage_age_field_dob: 'Дата рождения',
    consumerpage_age_field_home_country: 'Родина',
    consumerpage_age_field_hav_last_updated: 'Последнее обновление',
    consumerpage_age_field_hav_country: 'Страна',
    consumerpage_age_field_hav_type: 'Тип',
    consumerpage_age_field_hav_status: 'Статус',

    // Consumer page: Loyalty Programs tab
    consumerpage_loyalty_msg_consumer_not_registered:
        'Потребитель не является участником программы лояльности.',

    consumerpage_loyalty_field_current_points: 'Текущие баллы',
    consumerpage_loyalty_field_current_tier: 'Текущий уровень',
    consumerpage_loyalty_field_next_tier: 'Следующий уровень',
    consumerpage_loyalty_field_next_tier_points:
        'Баллы, необходимые для перехода на следующий уровень',
    consumerpage_loyalty_field_brand: 'Выберите бренд',

    consumerpage_loyalty_label_needs_recalc: 'НУЖДАЕТСЯ В ПЕРЕСЧЕТЕ',

    consumerpage_loyalty_btn_recalc: 'Пересчитать',
    consumerpage_loyalty_btn_recalc_requested: 'Запрошено',

    consumerpage_loyalty_tab_transactions: 'История транзакций',
    consumerpage_loyalty_tab_auditlogs: 'Журнал аудита',

    consumerpage_loyalty_transaction_column_time: 'Время транзакции',
    consumerpage_loyalty_transaction_column_type: 'Тип',
    consumerpage_loyalty_transaction_column_details: 'Подробности',
    consumerpage_loyalty_transaction_column_points: 'Точки',
    consumerpage_loyalty_transaction_column_remarks: 'Замечания',
    consumerpage_loyalty_transaction_column_created_by: 'Создание сайта',

    consumerpage_loyalty_logs_column_time: 'Время регистрации',
    consumerpage_loyalty_logs_column_rule_status: 'Статус правила',
    consumerpage_loyalty_logs_column_rule_type: 'Тип правила',
    consumerpage_loyalty_logs_column_rule_outcome: 'Результат правила',
    consumerpage_loyalty_logs_column_event_type: 'Тип события',
    consumerpage_loyalty_logs_column_event_id: 'Идентификатор события',
    consumerpage_loyalty_logs_column_event_name: 'Название события',
    consumerpage_loyalty_logs_column_corelation_id: 'Идентификатор корреляции',

    // Dialogs
    dialog_btn_yes: 'Да',
    dialog_btn_yes_confirm: 'Да, подтверждаю',
    dialog_btn_block: 'Заблокировать ',
    dialog_btn_no: 'Нет',
    dialog_btn_cancel: 'Отменить',
    dialog_get_consumer_error_title:
        'Ошибка при получении данных о пользователях.',
    dialog_get_consumer_error_text: 'Хотите повторить попытку?',
    dialog_password_reset_title: 'Сброс пароля',
    dialog_password_reset_text: 'Хотите продолжить?',
    dialog_consumer_block_title: 'Блокировка пользователя',
    dialog_consumer_block_text: 'Требуется дополнительная информация.',
    dialog_consumer_block_reason: 'Причина блокировки',
    dialog_consumer_unblock_title: 'Разблокировка пользователя',
    dialog_consumer_unblock_text: 'Вы действительно хотите продолжить?',
    dialog_consumer_delete_title: 'Удаление пользователя',
    dialog_consumer_delete_text: 'Вы действительно хотите продолжить?',
    dialog_unsaved_changes_title: 'Несохраненные изменения',
    dialog_unsaved_changes_text: 'Хотите отказаться от изменений?',
    dialog_save_changes_title: 'Сохранить данные',
    dialog_save_changes_text: 'Хотите продолжить?',
    dialog_last_name_change_title: 'Изменение имени пользователя',
    dialog_last_name_change_text:
        'Вы собираетесь изменить имя этого LAS, подтверждаете ли вы, что он/она отправил документ, удостоверяющий личность, чтобы подтвердить изменение?',
    dialog_last_name_change_text_generic:
        'Вы собираетесь изменить название этой LAS, вы действительно хотите продолжить?',
    dialog_set_hav_status_title: 'Настройка жесткого AV-статуса',
    dialog_set_hav_status_text: 'Хотите продолжить?',
    dialog_set_hav_status_confirm:
        'Вы собираетесь установить статус HAV для этой LAS, подтверждаете ли вы отправленный ими документ, удостоверяющий личность, чтобы подтвердить изменение?',

    // assign points dialog
    dialog_assign_points_title: 'Начислить баллы',
    dialog_assign_points_subtitle:
        'Вручную начислять баллы на счет потребителя в случае возникновения спорной ситуации.',
    dialog_assign_points_input_point_label: 'Количество баллов',
    dialog_assign_points_input_remark_label: 'Замечание',
    dialog_assign_points_cta_update_points: 'Добавить баллы',
    dialog_assign_points_invalid_points: 'Неверное количество баллов.',

    // OTP phone dialog - send code
    dialog_otp_phone_title: 'Change phone number',
    dialog_otp_phone_subtitle:
        'New phone number needs to be verified using OTP code.',
    dialog_otp_new_phone_number: 'New Phone Number',
    dialog_otp_new_phone_rejected: 'Phone number is already in use.',
    dialog_otp_btn_send: 'Send OTP',

    // OTP phone dialog - verify code
    dialog_otp_phone_verify_title: 'Verify OTP code',
    dialog_otp_phone_verify_subtitle:
        'Enter the OTP code provided by the Consumer.',
    dialog_otp_code: 'OTP Code',
    dialog_otp_code_invalid: 'Invalid format.',
    dialog_otp_code_rejected: 'OTP code is invalid.',
    dialog_otp_code_expired: 'OTP code has expired.',
    dialog_otp_btn_verify: 'Verify OTP',
    dialog_otp_btn_again: 'Send OTP Again',

    msg_otp_phone_send_code_ok: 'OTP code sent successfully.',
    msg_otp_phone_send_code_failed: 'Error requesting OTP code.',

    msg_otp_phone_verify_code_ok: 'Phone number changed successfully.',
    msg_otp_phone_verify_code_failed: 'Error verifying OTP code.',

    // Notifications messages
    msg_consumer_updated: 'Пользователь обновлён',
    msg_consumer_update_failed: 'Не удалось обновить пользователя.',
    msg_password_reset: 'Пароль успешно сброшен.',
    msg_password_reset_failed: 'Не удалось сбросить пароль.',
    msg_password_reset_not_available:
        'Сброс пароля недоступен для данного Пользователь.',
    msg_consumer_blocked: 'Пользователь заблокирован.',
    msg_consumer_block_failed: 'Не удалось заблокировать пользователя.',
    msg_consumer_unblocked: 'Пользователь разблокирован.',
    msg_consumer_unblock_failed: 'Не удалось разблокировать пользователя.',
    msg_consumer_deleted: 'Пользователь удален.',
    msg_consumer_delete_failed: 'Не удалось удалить пользователя.',
    msg_hav_status_updated: 'Обновлен статус HAV.',
    msg_hav_status_update_failed: 'Не удалось обновить статус HAV.',
    msg_loyalty_add_points_ok: 'Начислены баллы лояльности.',
    msg_loyalty_add_points_error: 'Ошибка при начислении баллов лояльности.',
    msg_loyalty_recalc_request_ok: 'Запрошен пересчет.',
    msg_loyalty_recalc_request_error: 'Ошибка при запросе пересчета.',
    msg_brand_data_fetch_error: 'Ошибка получения данных о бренде.',
    msg_market_changed: 'Рынок изменился.',
    msg_logged_out: 'Вышел из системы.',
    msg_session_lost:
        'Сессия пользователя потеряна, пожалуйста, войдите в систему снова.',
    msg_session_expired:
        'Сеанс пользователя истек, пожалуйста, войдите в систему снова',

    // General errors
    err_error_unknown: 'Произошла непредвиденная ошибка.',
    err_error_fetching_data: 'Ошибка при получении данных.',
    err_refresh: 'Oбновить',
    err_retry: 'Повторить попытку',

    // Misc
    misc_progress_indicator: 'Индикатор прогресса',

    // Dictionary: yes/no
    dict_yesno: {
        yes: 'Да',
        no: 'Нет',
    },

    // Dictionary: gender
    dict_gender: {
        m: 'Мужской',
        f: 'Женский',
        u: 'Неопределенный',
    },

    // Dictionary: language
    dict_language: {
        en: 'Английский',
        fr: 'Французский',
        de: 'Немецкий',
        es: 'Испанский',
        ph: 'Филиппинский',
        id: 'Индонезийский',
        ar: 'Арабский',
        ku: 'Курдский',
        uk: 'Украинский',
        ka: 'Грузинский',
        hy: 'Армянский',
        ru: 'Русский',
    },

    // Dictionary: country
    dict_country: {
        EC: 'Эквадор',
        DE: 'Германия',
        CH: 'Швейцария',
        PH: 'Филиппины',
        ID: 'Индонезия',
        PS: 'Палестина',
        IQ: 'Ирак',
        AR: 'Аргентина',
        EG: 'Египет',
        LB: 'Ливан',
        UA: 'Украина',
        MA: 'Марокко',
        GE: 'Грузия',
        JO: 'Иордания',
        AM: 'Армения',
        BO: 'Боливия',
    },

    // Dictionary: address type
    dict_address_type: {
        personal: 'Личный',
    },

    // Dictionary: HAV status
    dict_hav_status: {
        VERIFIED: 'ПОДТВЕРЖДЕНО',
        FAILED: 'ОШИБКА',
        NOT_VERIFIED: 'НЕ ПОДТВЕРЖДЕНО',
        IN_PROGRESS: 'В ПРОЦЕССЕ',
        RESET: 'СБРОС',
    },

    // Dictionary: last updated by
    dict_last_updated_by: {
        CONSUMER: 'ПОЛЬЗОВАТЕЛЬ',
    },

    // Dictionary: verification status
    dict_verification_status: {
        VERIFIED: 'ПОДТВЕРЖДЕНО',
        'NOT VERIFIED': 'НЕ ПОДТВЕРЖДЕНО',
        INVALID: 'НЕДЕЙСТВИТЕЛЬНО',
    },

    // Dictionary: blocking reason
    dict_blocking_reason: {
        FRAUDULENT: 'МОШЕННИЧЕСТВО',
        DEACTIVATED: 'ДЕАКТИВИРОВАНО',
        FOR_DELETION: 'НА УДАЛЕНИЕ',
        LAS_REQUEST: 'ЗАПРОС LAS',
        NON_SMOKER: 'НЕ КУРИТ',
        EMPLOYEE_TPA: 'СОТРУДНИК / TPA',
    },

    // Dictionary: loyalty transaction remark
    dict_loyalty_transaction_remark: {
        POINTS_DELETED: 'БАЛЛЫ УДАЛЕНЫ',
        POINTS_NOT_REFLECTED: 'БАЛЛЫ НЕ ОТОБРАЗИЛИСЬ',
        FAILURE_OF_REDEMPTION: 'ОШИБКА ПРИ СПИСАНИИ',
        OTHER_REASON: 'ДРУГАЯ ПРИЧИНА',
    },

    // Dictionary: loyalty transaction type
    dict_loyalty_transaction_type: {
        EARN: 'НАЧИСЛЕНИЕ',
        BURN: 'СПИСАНИЕ',
    },
};

export default messages;
